import { render, staticRenderFns } from "./campusDialog.vue?vue&type=template&id=73ef8512&"
import script from "./campusDialog.vue?vue&type=script&lang=js&"
export * from "./campusDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports